import Authenticator from 'components/economic-concret/authenticator';
import ErrorMessage from 'components/economic-concret/components/errorMessage';
import Loading from 'components/economic-concret/components/loading';
import SuccessMessage from 'components/economic-concret/components/successMessage';
import {useEffect, useState} from 'react';
import {Button, Card, Col, Dropdown, Form, Modal, Row, Table} from 'react-bootstrap';
import {Link, useNavigate} from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import api from '../../api/api';

export default function AllSuppliers() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);

  const [registeredSuppliers, setRegisteredSuppliers] = useState([]);

  const [showModalToSaveSupplier, setShowModalToSaveSupplier] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [cnpj, setCNPJ] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  // State for view modal
  const [showModalToViewSupplier, setShowModalToViewSupplier] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  useEffect(() => {
    getRegisteredSuppliers();
  }, []);

  function getRegisteredSuppliers() {
    setLoading(true);
    api
      .get('/suppliers', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setRegisteredSuppliers(returnFromApi.data);
      })
      .catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  }

  function closeModalToAddSupplier() {
    setShowModalToSaveSupplier(false);
  }

  function addSupplier() {
    const input = {
      name: name,
      cnpj: cnpj,
      phoneNumber: phoneNumber
    };

    api
      .post('/suppliers', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setShowModalToSaveSupplier(false);
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
        getRegisteredSuppliers();
        cleanFields();
      })
      .catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  }

  function updateSupplier() {
    const input = {
      supplierId: id,
      name: name,
      cnpj: cnpj,
      phoneNumber: phoneNumber
    };

    api
      .put('/suppliers', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setShowModalToSaveSupplier(false);
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
        getRegisteredSuppliers();
        cleanFields();
      })
      .catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  }

  function deleteSupplier(supplier) {
    setLoading(true);

    api
      .delete('/suppliers/' + supplier.supplierId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
        getRegisteredSuppliers();
        cleanFields();
      })
      .catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  }

  const saveSupplier = (event) => {
    event.preventDefault();
    setLoading(true);
    if (isUpdating) {
      updateSupplier();
    } else {
      addSupplier();
    }
  };

  function openSupplier(supplier) {
    setIsUpdating(true);
    setId(supplier.supplierId);
    setCNPJ(supplier.cnpj);
    setName(supplier.name);
    setPhoneNumber(supplier.phoneNumber);
    setShowModalToSaveSupplier(true);
  }

  function openModalToViewSupplier(supplier) {
    setSelectedSupplier(supplier);
    setShowModalToViewSupplier(true);
  }

  function closeModalToViewSupplier() {
    setShowModalToViewSupplier(false);
    setSelectedSupplier(null);
  }

  function cleanFields() {
    setId('');
    setCNPJ('');
    setName('');
    setPhoneNumber('');
  }

  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Authenticator />
      <Card.Header className="position-relative">
        <div className="row flex-between-center">
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Fornecedores Cadastrados</h5>
          </div>
          <div className="col-12 col-sm-auto ms-auto">
            <Button
              variant="falcon-primary"
              className="me-2 mb-1"
              onClick={() => {
                setIsUpdating(false);
                cleanFields();
                setShowModalToSaveSupplier(true);
              }}
            >
              Cadastrar Novo Fornecedor
            </Button>
          </div>
        </div>

        <Loading isToHidden={isLoading == false} />

        <div hidden={isLoading}>
          <div className="text-center" hidden={registeredSuppliers.length > 0}>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
              Nenhum fornecedor cadastrado ainda.
            </p>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0" hidden={registeredSuppliers.length == 0}>
        <Table responsive className={`form-container ${isLoading ? 'loading' : ''}`}>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">CNPJ</th>
              <th scope="col">Telefone</th>
              <th className="text-end" scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {registeredSuppliers.map((supplier) => {
              return (
                <tr key={supplier.supplierId}>
                  <td>{supplier.name}</td>
                  <td>{supplier.cnpj}</td>
                  <td>{supplier.phoneNumber}</td>
                  <td>
                    <Dropdown className="d-inline-block ms-2">
                      <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                      <Dropdown.Menu className="py-2">
                        <Dropdown.Item as={Link} onClick={() => openModalToViewSupplier(supplier)}>
                          Visualizar
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} onClick={() => openSupplier(supplier)}>
                          Editar
                        </Dropdown.Item>
                        <Dropdown.Divider as="div" />
                        <Dropdown.Item as={Link} onClick={() => deleteSupplier(supplier)} className="text-danger">
                          Excluir
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>

      <Modal
        show={showModalToSaveSupplier}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToAddSupplier()}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Fornecedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loading isToHidden={isLoading == false} />
          <Form onSubmit={saveSupplier} className={`form-container ${isLoading ? 'loading' : 'mt-3'}`}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Nome</Form.Label>
                  <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
              </Col>
              <Col xs={12} md={3}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">CNPJ</Form.Label>
                  <MaskedInput
                    mask={[
                      /\d/,
                      /\d/,
                      '.',
                      /\d/,
                      /\d/,
                      /\d/,
                      '.',
                      /\d/,
                      /\d/,
                      /\d/,
                      '/',
                      /\d/,
                      /\d/,
                      /\d/,
                      /\d/,
                      '-',
                      /\d/,
                      /\d/
                    ]}
                    className="form-control"
                    placeholder="00.000.000/0000-00"
                    value={cnpj}
                    onChange={(e) => setCNPJ(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={3}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Telefone</Form.Label>
                  <MaskedInput
                    mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    className="form-control"
                    placeholder="(00) 00000-0000"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              <Button type="submit">Salvar</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* View Supplier Modal */}
      <Modal
        show={showModalToViewSupplier}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToViewSupplier()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Detalhes do Fornecedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedSupplier && (
            <div className="supplier-details">
              <Row className="mb-3">
                <Col xs={12} md={6}>
                  <div className="detail-item">
                    <h6 className="fw-bold text-primary mb-1">Nome:</h6>
                    <p className="mb-0">{selectedSupplier.name}</p>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div className="detail-item">
                    <h6 className="fw-bold text-primary mb-1">CNPJ:</h6>
                    <p className="mb-0">{selectedSupplier.cnpj}</p>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs={12} md={6}>
                  <div className="detail-item">
                    <h6 className="fw-bold text-primary mb-1">Telefone:</h6>
                    <p className="mb-0">{selectedSupplier.phoneNumber}</p>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div className="detail-item">
                    <h6 className="fw-bold text-primary mb-1">ID:</h6>
                    <p className="mb-0">{selectedSupplier.supplierId}</p>
                  </div>
                </Col>
              </Row>
              {selectedSupplier.createdDate && (
                <Row className="mb-3">
                  <Col xs={12}>
                    <div className="detail-item">
                      <h6 className="fw-bold text-primary mb-1">Data de Cadastro:</h6>
                      <p className="mb-0">{selectedSupplier.formattedCreatedDate || selectedSupplier.createdDate}</p>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalToViewSupplier}>
            Fechar
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              closeModalToViewSupplier();
              openSupplier(selectedSupplier);
            }}
          >
            Editar
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
}
